import { Button } from 'components/atoms'
import PropTypes from 'prop-types'

import { NavItemLi } from './style'

const NavItemAnchor = ({ button, href, children, rel, target }) => (
  <NavItemLi>
    {button
      ? (
          <Button
            href={ href }
            rel={ rel }
            target={ target }
            variant="primary"
          >
            {children}
          </Button>
        )
      : <a href={ href }>{children}</a>}
  </NavItemLi>
)

NavItemAnchor.propTypes = {
  button: PropTypes.bool,
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  rel: PropTypes.string,
  target: PropTypes.string,
}

NavItemAnchor.defaultProps = {
  button: false,
}

export default NavItemAnchor
